"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = require("styled-components");
const styled_components_2 = require("styled-components");
const is_prop_valid_1 = __importDefault(require("@emotion/is-prop-valid"));
const theme_1 = require("./theme");
// This implements the default behavior from styled-components v5
function shouldForwardProp(propName, target) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return (0, is_prop_valid_1.default)(propName);
  }
  // For other elements, forward all props
  return true;
}
const WorthyThemeProvider = ({
  children,
  isMobile = false
}) => {
  return (0, jsx_runtime_1.jsx)(styled_components_2.StyleSheetManager, {
    enableVendorPrefixes: true,
    shouldForwardProp: shouldForwardProp,
    children: (0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, {
      theme: {
        ...theme_1.mainTheme,
        isMobile
      },
      children: children
    })
  });
};
exports.default = WorthyThemeProvider;